//@flow
import React, { type Node } from 'react';
import queryString from 'query-string';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { Button, Tooltip } from '@locus-taxy/neo-ui';
import { useTranslation } from 'react-i18next';
import { getSingleTripScreenPath } from 'common/trackIQ/utils/URLUtils';
import { clientSelectorV2 } from 'common/redux/selectors/queryParamsSelectors';

type Props = {
    riderId: string
};

const isLocationSame = (singleRiderLink, location) => {
    const { entityId } = queryString.parse(singleRiderLink.search);
    const { entityId: entityIdInUrl } = queryString.parse(location.search);
    return (
        singleRiderLink.pathname === location.pathname &&
        entityId === entityIdInUrl
    );
};

const MapButton = ({ riderId }: Props): Node => {
    const params = useParams();
    const clientId = clientSelectorV2(params);
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation('liveView');
    const singleTripScreenLink = getSingleTripScreenPath({
        clientId: clientId || '',
        location,
        queryParams: {
            entityId: riderId
        }
    });
    const isLocSame = isLocationSame(singleTripScreenLink, location);
    const tooltipTextKey = isLocSame
        ? 'returnToPreviousPage'
        : 'singleRiderLink';

    const handleClick = () => {
        if (isLocSame) {
            history.goBack();
        } else {
            history.push(singleTripScreenLink);
        }
    };

    return (
        <Tooltip tooltip={t(`riderManagerChat.${tooltipTextKey}`)}>
            <Button
                appearance="icon"
                icon={isLocSame ? 'motiontrack_revert_arrow' : 'location_map'}
                color="grey.600"
                size="medium"
                onClick={handleClick}
            />
        </Tooltip>
    );
};

export default MapButton;
